var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormItem',{attrs:{"label":"商品名称"}},[_c('BaseInput',{attrs:{"width":"370px","placeholder":"给SMT订单起个名字吧"},on:{"input":_vm.handleEmit},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }